import React, {useState} from 'react';
import {HeaderContainer} from './styles';
import {IconButton, Stack, Typography} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private';
import Icon from 'presentation/icons';

import {FacialBiometricsHeaderProps} from './types';
import {translations} from 'presentation/translations-new';
import {AbandonFlowModal} from 'presentation/components';
import {useNavigate} from 'react-router-dom';
import {HomeEnum} from 'presentation/constants';
import {FacialBiometricsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {CustomAlert} from '../CustomAlert';

const {abandonFlow, errorCard} = translations['pt-br'].others.facialBiometric;
const {facialBiometric} = translations['pt-br'].commons;

export function FacialBiometricsHeader({
	children,
	variant = 'default',
	showAbbandonFlowAlert,
}: FacialBiometricsHeaderProps) {
	const {isTablet} = useMediaQueries();

	const [abandonFlowState, setAbandonFlowState] = useState(false);
	const navigate = useNavigate();

	return (
		<>
			<HeaderContainer $variant={variant}>
				<Stack direction={'row'} alignItems="center" justifyContent="space-between">
					<Typography marginLeft={1} variant={isTablet ? 'h6' : 'h5'}>
						{facialBiometric}
					</Typography>
					<IconButton
						aria-label="close"
						color="inherit"
						onClick={() => setAbandonFlowState(true)}>
						<Icon name="close-filled" />
					</IconButton>
				</Stack>
				{children}
			</HeaderContainer>

			<AbandonFlowModal
				open={abandonFlowState}
				setOpen={setAbandonFlowState}
				title={abandonFlow.title}
				description={abandonFlow.description}
				subDescription={
					showAbbandonFlowAlert && <CustomAlert message={errorCard.divergentInfo.alert} />
				}
				headerTitle={abandonFlow.headerTitle}
				handleConfirm={() => navigate(HomeEnum.HOME_PAGE)}
				customIconName="info-filled"
				confirmButtondataTagId={
					FacialBiometricsTaggingEnum.CLICK_ABANDONAR_CADASTRO_BIOMETRIA_FACIAL
				}
			/>
		</>
	);
}
